import React, {ReactNode, useReducer} from "react";
import {ItemData, ItemsDispatcher} from "./ItemsProviderDomain";
import {itemsDataInitialState, ItemsReducer} from "./ItemsProviderReducer";

interface ViewProps {
    children?: ReactNode | undefined
}

const ItemsStateContext = React.createContext<ItemData>( itemsDataInitialState );
const ItemsDispatcherContext = React.createContext< React.Dispatch<ItemsDispatcher> >(() => null );

export function useItemsState(){
    const context = React.useContext(ItemsStateContext);
    if (context === undefined) {
        throw new Error("useItemsState must be used within a AlertProvider");
    }

    return context;
}

export function useItemsDispatcherState(){
    const context = React.useContext(ItemsDispatcherContext);
    if (context === undefined) {
        throw new Error("useAlertDispatcherState must be used within a AlertProvider");
    }

    return context;
}

export const ItemsProvider: React.FunctionComponent<ViewProps> = (props) => {
    const [items, itemsDispatch] = useReducer(ItemsReducer, itemsDataInitialState)

    return (
        <ItemsStateContext.Provider value={items}>
            <ItemsDispatcherContext.Provider value={itemsDispatch} >
                {props.children}
            </ItemsDispatcherContext.Provider>
        </ItemsStateContext.Provider>
    )
}